const REQUEST_METHODS = {
	get: 'GET',
	put: 'PUT',
	post: 'POST',
};

REQUEST_METHODS.has = (key='') => {
	return !!REQUEST_METHODS[key.toLowerCase()];
};

module.exports = REQUEST_METHODS;
